export const MEMBER_STATUSES = {
  eligible: 'eligible',
  ineligible: 'ineligible',
  registered: 'registered',
  deactivated: 'deactivated',
  dependent: 'dependent',
} as const

export const MEMBER_STATUSES_ARRAY = Object.keys(MEMBER_STATUSES)

export const MEMBER_SERVICE_LINE_STATUSES = {
  visible: 'visible',
  hidden: 'hidden',
  disabled: 'disabled',
  conditionallyEnabled: 'conditionally_enabled',
}

export const SERVICE_STATUS_DISPLAY = {
  [MEMBER_SERVICE_LINE_STATUSES.visible]: 'Visible',
  [MEMBER_SERVICE_LINE_STATUSES.hidden]: 'Hidden',
  [MEMBER_SERVICE_LINE_STATUSES.disabled]: 'Disabled',
  [MEMBER_SERVICE_LINE_STATUSES.conditionallyEnabled]: 'Conditionally Enabled',
}
